import React from 'react';
import PropTypes from 'prop-types';
import ChargeGroup from 'chargeComponents/ChargeGroup';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';
import { noChargeDwellingTypes } from '../../constants/dwellingTypes';
import { SPPServiceCodes } from '../../utils/helper';
class ChargeOptionsList extends React.Component {

    constructor(props) {
        super(props);
        this.saveCharges = this
            .saveCharges
            .bind(this);
    }

    saveCharges(e) {
        e.preventDefault();
        const { chargeOptions, orderId, chargeActions, user, accountNumber } = this.props;

        chargeOptions
            .get('details')
            .forEach((item) => {

                if (item.get('action') === 'add') {

                    chargeActions.chargeAddStarted({
                        userName: user.get('userId'),
                        jobNumber: orderId,
                        customerAccount: accountNumber,
                        comment: item.get('comment'),
                        quantity: item.get('quantity'),
                        billingSystemChargeID: item.get('billingSystemChargeID')

                    }, orderId);

                }
                if (item.get('action') === 'update') {
                    chargeActions.chargeUpdateStarted({
                        userName: user.get('userId'),
                        transactionID: item.get('transactionId'),
                        jobNumber: orderId,
                        customerAccount: accountNumber,
                        comment: item.get('comment'),
                        quantity: item.get('quantity'),
                        queueStatusTypeID: 1,
                        billingSystemChargeID: item.get('billingSystemChargeID')

                    }, orderId);
                }

            });

    }
    render() {
        const { chargeOptions, orderId, chargeActions, orderStatus, serviceTypeId, customerDetails, equipmentDetails, equipmentDetailsComplete } = this.props;

        let isGreenfield = false;
        if (customerDetails && customerDetails.get('signalAccessCode') === "X") {
            isGreenfield = true;
        }
        //find if the account's dwelling type is in the list of types with no charge.
        let isNoChargeDwellingType = false;
        if (customerDetails && noChargeDwellingTypes.includes(customerDetails.get('dwellingType'))) {
            isNoChargeDwellingType = true;
            console.log("Dwelling type marked as default to no charge.");
        }

        if (!chargeOptions || !chargeOptions.get('details') || chargeOptions.get('details').count() === 0) {
            return null;
        }

        let loadingMessage = null;

        if (chargeOptions.get('loading')) {
            loadingMessage = (
                <h6>Loading Charges...</h6>
            );
        }        

        const saveButtonStyle = {
            display: 'none'
        };

        const resultStyle = {
            marginTop: '25px'
        };

        const groupedOptions = chargeOptions
            .get('details')
            .groupBy(item => item.get('chargeGroup'))
            .toList();

        let hasError = false,
            hasSpp = false,
            sppMessage = '';

        if(equipmentDetails && equipmentDetails.get('details')) {
          hasSpp = equipmentDetails.get('details').some((item) =>
            item.get('serviceCodeList').some((sc) =>
              SPPServiceCodes.some(sppSC => sc.get('code').trim() === sppSC))
          );
        }

        if(equipmentDetailsComplete && equipmentDetailsComplete.get('details')) {
          hasSpp = equipmentDetailsComplete.get('details').some((item) =>
            item.get('serviceCodeList').some((sc) =>
            SPPServiceCodes.some(sppSC => sc.get('code').trim() === sppSC))
          );
        }

        const rows = groupedOptions.map((item, index) => {
            if (item.first().get('error')) {
                hasError = true;
            }

            //if spp is in the list, the customer must not currently have it.
            if (item.first().get('chargeGroup') === 'spp') {
                hasSpp = false;
            }

            // if spp is in the list, and the quantity is greater than 0, the customer has
            // spp now.
            if (item.first().get('chargeGroup') === 'spp' && item.first().get('quantity') > 0) {
                hasSpp = true;
            }

            // Prevents the sppMessage from being shown if it's greenfield
            if (isGreenfield) {
                hasSpp = false;
            }

            /*
                If not Greenfield then renders every ChargeGroup
                If Greenfield and chargeGroup NOT "spp" then renders
            */
            if (!isGreenfield || isGreenfield && item.first().get('chargeGroup') != 'spp') {
                return (<ChargeGroup
                    orderStatus={orderStatus}
                    chargeActions={chargeActions}
                    orderId={orderId}
                    chargeGroupSettings={chargeOptions.getIn([
                        'chargeGroups',
                        item
                            .first()
                            .get('chargeGroup')
                    ])}
                    key={'charge_selection_' + index}
                    chargeGroup={item}
                    isNoChargeDwellingType={isNoChargeDwellingType} />);
            }
        });

        const saveIcon = (
            <FontIcon className="material-icons">save</FontIcon>
        );

        if (hasError) {
            saveButtonStyle.display = '';
            saveButtonStyle.marginTop = '25px';
        }

        if (hasSpp && serviceTypeId.toLowerCase().includes('tc')) {
            sppMessage = (
                <p
                    style={{
                        fontSize: '18px',
                        fontWeight: 'bold'
                    }}>Customer has SPP/IWPP. Only add tech visit charge for non-covered issues.</p>
            );
        }


        return (
            <div>
                {loadingMessage}
                {sppMessage}
                <div>
                    <div>
                        <RaisedButton
                            label="Retry Save"
                            icon={saveIcon}
                            primary={true}
                            style={saveButtonStyle}
                            onTouchTap={this.saveCharges} />

                    </div>
                </div>

                <div style={resultStyle}>
                    {rows}
                </div>

            </div>
        );

    }
}

ChargeOptionsList.propTypes = {
    orderStatus: PropTypes.object,
    chargeOptions: PropTypes.object,
    user: PropTypes.object,
    orderId: PropTypes.string,
    chargeActions: PropTypes.object,
    accountNumber: PropTypes.string,
    serviceTypeId: PropTypes.string,
    equipmentDetailsComplete: PropTypes.object,
    equipmentDetails: PropTypes.object
};
export default ChargeOptionsList;



// WEBPACK FOOTER //
// ./src/components/charges/ChargeOptionsList.js